<template>
  <el-dialog title="编辑企业信息"
    :visible.sync="visible"
    width="35%"
    @closed='handleClose'
    :close-on-press-escape="false">
    <el-form :model="vendorInfo"
      :rules="rules"
      ref="ruleForm"
      label-width="138px">
      <el-form-item label="企业名称:"
        prop="vendorName">
        {{vendorInfo.vendorName}}
      </el-form-item>
      <el-form-item label="统一社会信用代码:"
        prop="unifiedCreditCode">
        {{vendorInfo.unifiedCreditCode}}
      </el-form-item>
      <el-form-item label="联系人:"
        prop="vendorPerson">
        <el-input v-model="vendorInfo.vendorPerson"></el-input>
      </el-form-item>
      <el-form-item label="手机号:"
        prop="vendorPhone">
        <el-input v-model="vendorInfo.vendorPhone"></el-input>
      </el-form-item>
      <el-form-item label="企业地址:"
        prop="vendorAddress">
        <el-input v-model="vendorInfo.vendorAddress"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱:"
        prop="vendorEmail">
        <el-input v-model="vendorInfo.vendorEmail"></el-input>
      </el-form-item>
      <!-- <el-form-item label="营业执照:"
        prop="businessLicenceFile">
        <upload-image v-model="vendorInfo.businessLicenceFile"
          :limit="1" />
      </el-form-item> -->
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import UploadImage from '@/components/public/upload-image-new.vue'
export default {
  name: 'ent-update-modal',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    fetch: {
      type: Function
    }
  },
  watch: {
    data: {
      handler (val) {
        this.vendorInfo = {
          ...this.vendorInfo,
          ...val
        }
      },
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      vendorInfo: {
        vendorName: '',
        vendorPerson: '',
        vendorPhone: '',
        unifiedCreditCode: '',
        vendorEmail: '',
        vendorAddress: '',
        businessLicenceFile: []
      },
      rules: {
        vendorName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        vendorPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        vendorPhone: [
          { required: true, pattern: /^1[0-9][0-9]\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        unifiedCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        vendorEmail: [
          { required: true, type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        vendorAddress: [
          { required: true, message: '请输入企业地址', trigger: 'blur' }
        ],
        businessLicenceFile: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('vendor/updatevendor', {
            payload: {
              vendorId: this.$route.query.vendorId,
              ...this.vendorInfo,
              businessLicenceFile: this.vendorInfo.businessLicenceFile.map(item => item.url).join(',')
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.fetch && this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
